import { __decorate } from "tslib";
import { Component, Vue, Emit, Prop, Ref } from 'vue-property-decorator';
import moment from 'moment';
import { resolveAlarmList, incidentRecordsFavorite } from '@blade/common/api/alarm-center';
import authItem from '@blade/common/components/auth/auth-item.vue';
import { formatTime } from '@blade/common/pages/crowd-queue-right/utils/index';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
import sliderInput from '@blade/common/components/slider-input/index.vue';
import deviceSelect from '@blade/common/components/device-cascader-select/index.vue';
import SnapPicture from '@blade-sxp/monitor-center/pages/components/snap-picture/index.vue';
// import { getSnapImageListByImage, detectTypes } from '@blade-sxp/monitor-center/api/index';
import { getSnapImageListByImage } from '@blade-sxp/monitor-center/api/index';
import { permissionlevel } from '@blade/common/constants/role-mode';
import AuthNewitem from '@blade/common/components/auth/auth-newItem.vue';
import { formatSnapImageList } from '@blade-sxp/monitor-center/utils';
import AnalysisResult from '@blade-sxp/monitor-center/pages/components/analysis-result/index.vue';
import DetailsLeft from '@blade/common/pages/alert-details/components/details-left.vue';
// import DetailsLeft from '@blade/common/pages/result-details/components/details-left.vue';
// import ImageUtil from '@blade/common/utils/image-util';
import { AccountModule } from '@blade-sxp/account/store/account';
import { downImage } from '@blade/common/utils/down-image';
import detailsRight from '@blade-sxp/monitor-center/pages/components/alarm-details/details-right.vue';
import lang from '@blade-sxp/monitor-center/lang/index';
let AlarmDetails = class AlarmDetails extends Vue {
    cardShow;
    elImage;
    details;
    dialogTableVisible = true;
    privacyMode = localStorage.getItem('privacyMode') || 'false';
    filterImgLv = this.privacyMode === 'true' ? 6 : 0;
    timeFormat(time, format = 'yy-MM-DD HH:mm:ss') {
        return moment(Number(time)).format(format) || '--';
    }
    offset = {};
    srcList = [];
    indexImg = 0;
    zoomNum = 0;
    zoomScale = '';
    x = '';
    y = '';
    disX = 0;
    disY = 0;
    permissionLevel = permissionlevel;
    formatTime = formatTime;
    // url传递的参数
    getImage;
    loading = false;
    // 抓拍记录参数
    form = {
        dates: [moment().add(-7, 'd').format('yyyy-MM-DD HH:mm:ss'), moment().format('yyyy-MM-DD HH:mm:ss')],
        deviceIds: [],
        similarity: 95,
        // time: '1',
        groupTime: 1440,
    };
    isDeviceChange = false;
    cascaderStatus = false;
    pageSize = 20;
    permissionCode = '02';
    options = [
        {
            value: 10,
            label: '10 Min',
        },
        {
            value: 30,
            label: '30 Min',
        },
        {
            value: 60,
            label: '60 Min',
        },
        {
            value: 1440,
            label: '24 Hour',
        },
    ];
    allFilter = false;
    snapImageList = [];
    layer = true;
    noteMark = '';
    downImage = downImage;
    getOffset() {
        if (this.dialogTableVisible) {
            this.offset.x = (window.innerWidth - this.$refs.detailsRef.offsetWidth) / 2;
            this.offset.y = (window.innerHeight - this.$refs.detailsRef.offsetHeight) / 2;
        }
    }
    get getFavoriteClass() {
        return this.details.favoritesInfos && this.details.favoritesInfos?.favorite ? 'icon-alert-unstarred' : '';
    }
    get getFavorite() {
        return this.details.favoritesInfos && this.details.favoritesInfos?.favorite ? 'alert-unstarred' : 'alert-star';
    }
    get getRemark() {
        const remarks = this.noteMark ? this.noteMark : '-';
        return remarks;
    }
    downImg() {
        this.downImage(this.srcList[this.indexImg].url);
    }
    handleStar() {
        const favorite = !(this.details.favoritesInfos && this.details.favoritesInfos?.favorite);
        const param = {
            favoritesInfosDTOS: [
                {
                    favorite: favorite,
                    operatorInformations: [
                        {
                            createTime: this.details.alertTime,
                            timeStamp: this.details.alertTime,
                            userId: this.userInfo?.id || '1',
                            userName: this.userInfo?.user_name || 'sxtest',
                        },
                    ],
                    recordId: this.details.id,
                },
            ],
        };
        incidentRecordsFavorite(param)
            .then((res) => {
            if (favorite) {
                this.$message({
                    message: res,
                    type: 'success',
                });
            }
            else {
                this.$message({
                    message: res,
                    type: 'success',
                });
            }
            this.$emit('updateDialog');
        })
            .catch((err) => {
            this.$message({ message: err, type: 'error' });
        });
    }
    updateDialog() {
        this.$emit('updateDialog');
    }
    handleClick() { }
    onNumberInput(v) {
        this.form.similarity = +v.match(/^[0-9]+/g)[0];
    }
    // 设备筛选关闭弹窗
    cascaderStatusChange(status) {
        this.cascaderStatus = status;
        if (!status && this.isDeviceChange) {
            this.isDeviceChange = false;
            this.getSnapImage();
        }
    }
    // 设备筛选value更改
    deviceChange() {
        this.isDeviceChange = true;
        if (!this.cascaderStatus) {
            this.isDeviceChange = false;
            this.getSnapImage();
        }
    }
    changeClick(e) {
        this.indexImg = e;
        let width = document.querySelectorAll('.classifys-item')[this.indexImg].offsetLeft;
        document.getElementById('classifyScroll').scrollLeft = width - 10; // 通过scrollTop设置滚动到200位置
    }
    showImg(e) {
        this.indexImg = e;
        this.$refs.cardShow.setActiveItem(this.indexImg);
    }
    handleLeft() {
        if (this.indexImg > 0) {
            this.$refs.cardShow.setActiveItem(this.indexImg - 1);
        }
        else {
            this.$refs.cardShow.setActiveItem(this.indexImg - 1);
        }
    }
    handleRight() {
        if (this.indexImg > 0) {
            this.$refs.cardShow.setActiveItem(this.indexImg - 1);
        }
        else {
            this.$refs.cardShow.setActiveItem(this.indexImg - 1);
        }
    }
    handleFullScreen() {
        this.$refs.imgaeScrenn.clickHandler();
        const filterClassName = ['-webkit-filter', '-moz-filter', '-ms-filter', 'filter'];
        filterClassName.forEach((item) => {
            this.$nextTick(() => {
                document.getElementsByClassName('el-image-viewer__canvas')[0].style[item] = `blur(${this.filterImgLv}px)`;
            });
        });
    }
    closeDialog() {
        // console.log('点击');
    }
    confirmDia(id, status) {
        return { id, status };
    }
    handleDelete() {
        this.$confirm(this.$t('confirmDelete').toString(), this.$t('tips').toString(), {
            customClass: 'alert-confirm-index',
            confirmButtonText: this.$t('common.confirm').toString(),
            cancelButtonText: this.$t('common.cancel').toString(),
            cancelButtonClass: 'cancel-roi-tip',
            confirmButtonClass: 'confirm-roi-tip',
            type: 'warning',
        })
            .then(() => {
            this.resolveAlarmList(this.details.id, 'DELETE');
        })
            .catch(() => { });
    }
    handleIgnore() {
        this.$confirm(this.$t('confirmIgnore').toString(), this.$t('tips').toString(), {
            customClass: 'alert-confirm-index',
            confirmButtonText: this.$t('common.confirm').toString(),
            cancelButtonText: this.$t('common.cancel').toString(),
            cancelButtonClass: 'cancel-roi-tip',
            confirmButtonClass: 'confirm-roi-tip',
            type: 'warning',
        })
            .then(() => {
            this.resolveAlarmList(this.details.id, 'NO_REPORT');
        })
            .catch(() => { });
    }
    handleSolved() {
        this.$confirm(this.$t('confirmSolved').toString(), this.$t('tips').toString(), {
            customClass: 'alert-confirm-index',
            confirmButtonText: this.$t('common.confirm').toString(),
            cancelButtonText: this.$t('common.cancel').toString(),
            cancelButtonClass: 'cancel-roi-tip',
            confirmButtonClass: 'confirm-roi-tip',
            type: 'warning',
        })
            .then(() => {
            this.resolveAlarmList(this.details.id, 'VERIFIED');
        })
            .catch(() => { });
    }
    get userInfo() {
        return AccountModule.accountInfo;
    }
    resolveAlarmList(id, resolveStatus) {
        const newNote = {
            operatorInformation: {
                createTime: this.details.alertTime,
                timeStamp: this.details.alertTime,
                userId: this.userInfo?.id,
                userName: this.userInfo?.user_name,
            },
            remark: this.noteMark,
        };
        const reqParam = {
            resolveAlertElements: [
                {
                    id: id,
                    remarks: [newNote],
                    resolveStatus: resolveStatus !== '' ? resolveStatus : null,
                },
            ],
        };
        resolveAlarmList({ ...reqParam })
            .then((res) => {
            this.$message({
                message: res,
                type: 'success',
            });
            this.confirmDia(id, resolveStatus);
        })
            .catch(() => { });
    }
    getSnapImage() {
        this.snapImageList = [];
        this.loading = true;
        this.getImage
            .then(({ base64Image: imageUrl, featureList }) => {
            const { dates, groupTime, similarity, deviceIds: deviceIdList } = this.form;
            const [startTime = moment().add(-7, 'd').format('yyyy-MM-DD HH:mm:ss'), endTime = moment().format('yyyy-MM-DD HH:mm:ss')] = dates || [];
            return getSnapImageListByImage({
                deviceIdList,
                dateStart: startTime,
                dateEnd: endTime,
                page: 1,
                size: this.pageSize,
                imageSearchRequest: {
                    threshold: +similarity / 100,
                    imageUrl: imageUrl,
                    featureList: featureList,
                },
            }).then((res) => {
                let list = [];
                res.searchList.forEach((item) => {
                    if (item.list) {
                        list = list.concat(item.list);
                    }
                });
                this.snapImageList = formatSnapImageList(list, groupTime);
            });
        })
            .catch(() => {
            this.snapImageList = [];
        })
            .finally(() => {
            this.loading = false;
        });
    }
    handleSnapRecord(snapImage) {
        const { dates: [startTime, endTime] = [] } = this.form;
        this.$router.push({ path: '/businessPortal/snapRecord', query: { deviceId: String(snapImage.deviceId), startTime, endTime } });
    }
    initParams() {
        this.srcList = [];
        let persons = [];
        if (this.details.incidentType === 'FACE_MATCH' ||
            this.details.incidentType === 'FACE_PEDESTRIAN' ||
            this.details.incidentType === 'INCIDENT_FACE_UNMATCHED') {
            if (this.details.pedestrianAnnotation) {
                this.details.pedestrianAnnotation.personGroups.forEach((item) => {
                    item.targets.forEach((data) => {
                        persons.push({
                            vertices: data.rectangle.vertices,
                            type: 'rect',
                        });
                    });
                });
                this.srcList.push({ url: this.details.pedestrianAnnotation.panoramicImage, persons });
                this.srcList.push({ url: this.details.pedestrianAnnotation.portraitCaptureImage });
            }
            else if (this.details?.faceAnnotation) {
                try {
                    this.details.faceAnnotation.personGroups.forEach((item) => {
                        item.targets.forEach((data) => {
                            persons.push({
                                vertices: data.rectangle.vertices,
                            });
                        });
                    });
                }
                catch (error) { }
                this.srcList.push({ url: this.details.faceAnnotation.panoramicImage, persons });
                this.srcList.push({ url: this.details.faceAnnotation.portraitCaptureImage });
            }
        }
        else {
            this.srcList.push({ url: this.details.panoramicImage });
        }
        this.loading = true;
        // if (!this.getImage) {
        //   // 获取图片中的特征
        //   const canvas = document.createElement('canvas');
        //   const targetImg = this.srcList[0].url;
        //   this.getImage = ImageUtil.drawImage(targetImg, canvas).then(() => {
        //     const base64Image = canvas.toDataURL();
        //     return detectTypes({ base64Image }).then((data: any) => {
        //       let featureList: Feature[] = [];
        //       data.forEach((item: any) => {
        //         if (item.featureList) {
        //           featureList = featureList.concat(
        //             item.featureList.map((feature: any) => {
        //               return {
        //                 ...feature,
        //                 imageUrl: '',
        //               };
        //             })
        //           );
        //         }
        //       });
        //       if (!featureList || !featureList.length) {
        //         // this.$message.error('未检测到人脸人体');
        //         // eslint-disable-next-line no-throw-literal
        //         throw '没有识别到人脸人体';
        //       } else {
        //         return {
        //           featureList,
        //           base64Image,
        //         };
        //       }
        //     });
        //   });
        // }
    }
    mounted() {
        this.initParams();
        if (Array.isArray(this.details.remarks)) {
            this.noteMark = this.details.remarks[0]?.remark;
        }
    }
};
__decorate([
    Ref()
], AlarmDetails.prototype, "cardShow", void 0);
__decorate([
    Ref()
], AlarmDetails.prototype, "elImage", void 0);
__decorate([
    Prop()
], AlarmDetails.prototype, "details", void 0);
__decorate([
    Emit('closeDialog')
], AlarmDetails.prototype, "closeDialog", null);
__decorate([
    Emit('confirmDialog')
], AlarmDetails.prototype, "confirmDia", null);
AlarmDetails = __decorate([
    Component({
        components: { authItem, BlurPicture, deviceSelect, SnapPicture, sliderInput, AnalysisResult, AuthNewitem, DetailsLeft, detailsRight },
        i18n: {
            messages: lang,
        },
    })
], AlarmDetails);
export default AlarmDetails;
